import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { ChannelManagement } from '../modal';

export default function reducer(state: ChannelManagement = new ChannelManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.CHL_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.CHL_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.CHL_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
